<template>
  <div class="props-group">
    <el-form-item label-width="120px">
      <span slot="label">锁定行数
      <el-tooltip content="开启锁定行数后，用户将不可添加或删除行。" placement="top" class="tooltip">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      </span>
      <el-switch v-model="component.properties.lockRow" @change="$emit('update', 'lock-row')"></el-switch>
    </el-form-item>

  </div>
</template>

<script>
export default {
  name: 'attr-lock-row',
  props: ['component']
}

</script>

<style lang="scss">
  .props-group {
    .el-form-item {
      .el-form-item__label {
        .tooltip {
          color: #c2c3c4;

          &:hover {
            color: #409EFF;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/lock-row.vue